import { render, staticRenderFns } from "./DetailsRyCard.vue?vue&type=template&id=0d744085&scoped=true&"
import script from "./DetailsRyCard.vue?vue&type=script&lang=js&"
export * from "./DetailsRyCard.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRyCard.vue?vue&type=style&index=0&id=0d744085&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d744085",
  null
  
)

export default component.exports